import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './page/login/login.component';

// toat
import { ToastrModule } from 'ngx-toastr';

// map
import { AgmCoreModule } from '@agm/core';

// common
import { CommonService } from './service/common.service';
import { LoadingBoxComponent } from './part/loading-box/loading-box.component';
import { DashboardComponent } from './page/dashboard/dashboard.component';
import { NavbarComponent } from './part/navbar/navbar.component';
import { SettingComponent } from './page/setting/setting.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LoadingBoxComponent,
    DashboardComponent,
    NavbarComponent,
    SettingComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    ToastrModule.forRoot({
      timeOut: 4000,
      positionClass: 'toast-top-right',
      progressBar: true
    }), // ToastrModule added, 
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBQWzgL9NZfKxG9yJ6wkcKQh68u762NWVA'
    }),
  ],
  providers: [CommonService],
  bootstrap: [AppComponent]
})
export class AppModule { }
